<div class="main_body">
  <app-page-header
    title="セクション"
    i18n-title="@@adminSectionGroup.sectionsList.title.sectionList"
    subtitle="セクションの情報の閲覧・編集を行います。"
    i18n-subtitle="@@adminSectionGroup.sectionsList.description.viewEdit"
    icon="section"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="table-toolbar">
          <!-- Left: Search Pill -->
          <div
            class="search-pill"
            [class.expanded]="searchExpanded()"
            [class.has-value]="filter.trim()"
            (click)="expandSearch()"
            role="search"
          >
            <mat-icon class="search-pill__icon">search</mat-icon>
            @if (!searchExpanded() && !filter.trim()) {
              <span class="search-pill__placeholder" i18n="@@adminSectionGroup.sectionsList.placeholder.sectionFilter">セクション フィルター</span>
            }
            <input
              #searchInput
              type="text"
              class="search-pill__input"
              [value]="filter"
              (input)="applyFilter($event)"
              (blur)="onSearchBlur()"
              [attr.aria-label]="'セクション フィルター'"
              i18n-aria-label="@@adminSectionGroup.sectionsList.search.ariaLabel"
            />
            @if (filter.trim()) {
              <button
                type="button"
                class="search-pill__clear"
                (click)="clearSearch($event)"
                aria-label="検索をクリア"
                i18n-aria-label="@@adminSectionGroup.sectionsList.search.clearAriaLabel"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>

          <!-- Right: Actions -->
          <div class="table-toolbar__actions">
            @if (hasSectionManagement || hasAllSectionGroupManagement) {
              <button
                mat-icon-button
                class="table-toolbar__btn"
                (click)="openCreateSectionDialog()"
                matTooltip="新規作成"
                aria-label="新規作成"
                i18n-matTooltip="@@adminSectionGroup.sectionsList.tooltip.createNew"
                i18n-aria-label="@@adminSectionGroup.sectionsList.ariaLabel.createNew"
              >
                <mat-icon>add</mat-icon>
              </button>
            }
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="refreshData()"
              matTooltip="更新"
              aria-label="更新"
              i18n-matTooltip="@@adminSectionGroup.sectionsList.tooltip.refresh"
              i18n-aria-label="@@adminSectionGroup.sectionsList.ariaLabel.refresh"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>

        <div class="user-list-container mat-elevation-z0">
          @if (isLoading()) {
            <app-table-skeleton [rows]="5" />
          } @else {
            <table class="entry-table staff" mat-table [dataSource]="dataSource" matSort matSortActive="status" matSortDirection="desc">

              <ng-container matColumnDef="sectionName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 200px;" i18n="@@adminSectionGroup.sectionsList.table.sectionName"> セクション名 </th>
                <td mat-cell *matCellDef="let row">
                  {{row.sectionName}}
                </td>
              </ng-container>

              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 200px;" i18n="@@adminSectionGroup.sectionsList.table.description"> 説明 </th>
                <td mat-cell *matCellDef="let row">
                  {{row.description}}
                </td>
              </ng-container>


              <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef style="min-width: 90px;" i18n="@@adminSectionGroup.sectionsList.table.address"> 所在地 </th>
                <td mat-cell *matCellDef="let row">
                  {{row.prefecture + ' ' + row.city}}
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;" i18n="@@adminSectionGroup.sectionsList.table.status"> ステータス </th>
                <td mat-cell *matCellDef="let row">
                  @if (row.contractStatus == 'OPEN') {
                    <span class="status-badge status-badge--active">{{accountStatus[row.contractStatus]}}</span>
                  } @else {
                    <span class="status-badge status-badge--inactive">{{accountStatus[row.contractStatus]}}</span>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="admins" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@adminSectionGroup.sectionsList.table.primaryStaff"> プライマリスタッフ </th>
                <td mat-cell *matCellDef="let row" >
                  @if (row.admins && row.admins.length > 0) {
                    <div>
                      @for (admin of row.admins; track admin) {
                        <div>
                          @if (admin.contractInfo.contractStatus.toUpperCase() == 'OPEN') {
                            <div>
                              <div [id]="row.id+'+'+admin.user.userId" class="container">
                                <div class="">
                                  <span class="admin-text">{{ admin.user.lastName }} {{ admin.user.firstName }}</span>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openSectionDetailDialog(row)" >
              </tr>
            </table>
          }
        </div>
        <mat-paginator class="user-list-paginator" [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50, 100]"></mat-paginator>
      </section>
    </div>
    <!--/contents_section_group-->
  </div>
  <!--/contents-->
</div>
